<template>
  <MWNavbar />
  <main class="overlay w-full text-sm text-white bg-[#003d31]">
    <section class="relative w-full overflow-hidden">
      <div class="relative w-screen h-[80vh]">
        <iframe
          src="https://www.youtube.com/embed/5YW9LLdbU0U?autoplay=1&mute=1&loop=1&playlist=5YW9LLdbU0U&controls=0&modestbranding=1&iv_load_policy=3&rel=0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
          class="absolute top-[-15%] left-[-10%] w-[120%] h-[135%] overflow-hidden"
        ></iframe>
      </div>
      <div
        class="absolute bottom-0 left-0 h-1/2 w-full bg-gradient-to-t from-[#003d31] to-transparent"
      ></div>
      <div class="overlay absolute top-0 left-0 w-full h-full"></div>
      <div
        class="absolute top-0 left-0 flex justify-center items-center w-full h-full"
      >
        <div class="max-w-[1200px] w-full max-[1210px]:px-5">
          <h3 class="text-base sm:text-xl md:text-2xl lg:text-3xl mb-3">
            Shangri-La Ulaanbaatar, Mongolia Oct 07-10
          </h3>
          <h1 class="font-bold text-2xl md:text-4xl lg:text-8xl uppercase">
            Mining Week 2024
          </h1>
        </div>
      </div>
    </section>

    <!-- 2 buttons -->
    <section class="relative flex justify-center h-[55vh]">
      <div
        class="absolute top-20 flex max-sm:flex-col items-center max-w-[1200px] max-[1210px]:px-5 w-full gap-5"
      >
        <button
          class="px-6 py-2 border border-white uppercase hover:bg-[#00a375]"
        >
          {{ lang === "mn" ? "Хөтөлбөр" : "Agenda" }}
        </button>
        <button
          class="px-6 py-2 border border-white uppercase hover:bg-[#00a375]"
        >
          {{ lang === "mn" ? "Бүртгүүлэх" : "Registration" }}
        </button>
      </div>
    </section>

    <!-- Portfolio -->
    <section class="flex justify-center py-20">
      <div class="max-w-[1200px] w-full">
        <!-- navigations -->
        <div class="flex max-sm:flex-col justify-center items-center gap-3">
          <button
            @click="setFilter('all')"
            class="px-6 py-2 border uppercase"
            :class="filter === 'all' ? 'bg-[#00a375]' : 'hover:bg-[#00a375]'"
          >
            {{ lang === "mn" ? "Бүгд" : "ALL" }}
          </button>
          <button
            @click="setFilter('Mining week 2022')"
            class="px-6 py-2 border uppercase"
            :class="
              filter === 'Mining week 2022'
                ? 'bg-[#00a375]'
                : 'hover:bg-[#00a375]'
            "
          >
            Miningweek 2022
          </button>
          <button
            @click="setFilter('Mining week 2023')"
            class="px-6 py-2 border uppercase"
            :class="
              filter === 'Mining week 2023'
                ? 'bg-[#00a375]'
                : 'hover:bg-[#00a375]'
            "
          >
            Miningweek 2023
          </button>
        </div>

        <!-- gallery -->
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-around gap-8 mx-10 mt-10"
        >
          <div
            v-for="(portfolio, index) in filteredPortfolio"
            :key="index"
            class="group relative rounded-xl"
            @mouseenter="showOverlay()"
            @mouseleave="showOverlay()"
            v-motion-pop-visible-once
            :duration="300"
          >
            <img :src="portfolio.image" :alt="index" class="rounded-xl" />
            <Transition name="slide-fade">
              <div
                v-if="isOverlay"
                class="invisible group-hover:visible absolute top-0 left-0 w-full h-full p-5"
              >
                <div
                  class="relative flex flex-col justify-end bg-[#003d31] bg-opacity-80 w-full h-full text-white rounded-xl p-5"
                >
                  <button
                    v-motion-slide-visible-right
                    :delay="100"
                    :duration="300"
                    class="absolute top-5 right-5 flex justify-center items-center p-2 border rounded-full"
                  >
                    <font-awesome-icon icon="fa-regular fa-image" />
                  </button>
                  <h1
                    v-motion-slide-visible-bottom
                    :delay="100"
                    :duration="300"
                    class="text-base"
                  >
                    {{ portfolio.title }}
                  </h1>
                  <h5
                    v-motion-slide-visible-bottom
                    :delay="100"
                    :duration="300"
                    class="mt-3 font-bold text-xl"
                  >
                    {{ portfolio.description }}
                  </h5>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </section>

    <!-- News -->
    <section class="flex justify-center items-center">
      <div class="max-w-[1200px] w-full my-20 max-[1210px]:px-5">
        <h1
          v-motion-slide-visible-once-bottom
          class="font-bold text-center uppercase text-lg"
        >
          {{ lang === "mn" ? "Мэдээ мэдээлэл" : "Latest news" }}
        </h1>
        <div
          v-motion-slide-visible-once-bottom
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10"
        >
          <div
            v-for="(item, index) in news"
            :key="index"
            class="shadow-[0px_16px_32px_rgb(0_0_0/44%)]"
          >
            <img
              :src="item.image"
              :alt="index"
              class="w-full h-[15rem] object-cover object-center"
            />
            <div class="bg-[#003d31] p-5 space-y-2 md:space-y-4">
              <h4 class="text-xs">{{ item.publisher }}</h4>
              <h1 class="line-clamp-1 text-lg">{{ item.title }}</h1>
              <button class="flex items-center hover:text-[#00a375]">
                {{ lang === "mn" ? "Дэлгэрэнгүй" : "Read more"
                }}<font-awesome-icon
                  icon="fa-solid fa-arrow-right-long"
                  class="ml-3 text-xs"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Organizers -->
    <section class="flex justify-center items-center pt-10 pb-40">
      <div
        class="flex flex-col justify-center items-center max-w-[1200px] w-full"
      >
        <h1 class="font-bold text-center uppercase text-lg">
          {{ lang === "mn" ? "Зохион байгуулагч" : "Organizer" }}
        </h1>
        <div
          class="flex max-sm:flex-col max-sm:items-center max-sm:space-y-5 sm:space-x-10 mt-10"
        >
          <img
            src="../../assets/images/miningWeek/spons-logo-1.png"
            alt="logo"
            class="w-[15rem] object-fit"
          />
          <img
            src="../../assets/images/miningWeek/spons-logo-2.png"
            alt="logo"
            class="w-[15rem] object-fit"
          />
        </div>
      </div>
    </section>
  </main>

  <MWFooter />
  <QuickContact :backgroundColor="'bg-[#00a375]'" />
  <BackToTheTopButton :backgroundColor="'bg-[#00a375]'" />
</template>

<script>
import { ref, watchEffect, computed } from "vue";
import { useStore } from "vuex";

import MWNavbar from "../../components/MiningWeek/MWNavbar";
import MWFooter from "@/components/MiningWeek/MWFooter.vue";
import BackToTheTopButton from "@/components/ui/BackToTheTopButton.vue";
import QuickContact from "@/components/ui/QuickContact.vue";

export default {
  name: "MWHomePage",
  components: {
    MWNavbar,
    MWFooter,
    BackToTheTopButton,
    QuickContact,
  },
  setup() {
    const store = useStore();
    const lang = ref();

    watchEffect(() => {
      lang.value = store.getters.getLanguage;
    });

    const portfolio = [
      {
        title: "Mining week 2023",
        description: "Mining week 2023",
        image: require("../../assets/images/miningWeek/week-1.jpeg"),
      },
      {
        title: "Mining week 2023",
        description: "Mining week 2023",
        image: require("../../assets/images/miningWeek/week-2.jpeg"),
      },
      {
        title: "Mining week 2023",
        description: "Mining week 2023",
        image: require("../../assets/images/miningWeek/week-3.jpeg"),
      },
      {
        title: "Mining week 2022",
        description: "Mining week 2022",
        image: require("../../assets/images/miningWeek/week-4.jpeg"),
      },
      {
        title: "Mining week 2022",
        description: "Mining week 2022",
        image: require("../../assets/images/miningWeek/week-5.jpeg"),
      },
      {
        title: "Mining week 2022",
        description: "Mining week 2022",
        image: require("../../assets/images/miningWeek/week-6.jpeg"),
      },
    ];

    const news = [
      {
        title: "Салбар хурлууд",
        publisher: "By Admin, 07 Oct, 2023",
        image: require("../../assets/images/miningWeek/news/news-1.png"),
      },
      {
        title: "Mining Week 2023",
        publisher: "By Admin, 21 Sep, 2023",
        image: require("../../assets/images/miningWeek/news/news-2.png"),
      },
      {
        title: "2023 оны 10 дугаар сарын 09-өөс 13-ны хооронд",
        publisher: "By Admin, 21 Sep, 2023",
        image: require("../../assets/images/miningWeek/news/news-3.png"),
      },
    ];

    const filter = ref("all");
    const setFilter = (selectedFilter) => {
      filter.value = selectedFilter;
    };

    const filteredPortfolio = computed(() => {
      if (filter.value === "all") {
        return portfolio;
      }
      return portfolio.filter((item) => item.title === filter.value);
    });

    const isOverlay = ref(false);
    const showOverlay = () => {
      isOverlay.value = !isOverlay.value;
    };

    return {
      lang,
      filter,
      setFilter,
      filteredPortfolio,
      news,
      isOverlay,
      showOverlay,
    };
  },
};
</script>

<style scoped>
.overlay {
  background-image: url("../../assets/images/miningWeek/diagonalstripe-black.png");
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 2s ease-out;
}

.slide-up-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
